define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.getSubPolygon = exports.getRenderedSize = exports.clamp = exports.isPointInInterval = exports.isNumberInInterval = exports.config = void 0;
    const config = (defaultConfig, providedConfig) => (Object.assign(Object.assign({}, defaultConfig), providedConfig));
    exports.config = config;
    const isNumberInInterval = (x, a, b) => (a <= b ? a : b) <= x && x <= (a <= b ? b : a);
    exports.isNumberInInterval = isNumberInInterval;
    const isPointInInterval = (p, a, b) => exports.isNumberInInterval(p.x, a.x, b.x) && exports.isNumberInInterval(p.y, a.y, b.y);
    exports.isPointInInterval = isPointInInterval;
    const clamp = (x, a, b) => {
        if (a < b)
            return Math.min(Math.max(a, x), b);
        return Math.min(Math.max(b, x), a);
    };
    exports.clamp = clamp;
    const getRenderedSize = (canvasSize, imageSize) => {
        const imageRatio = imageSize.width / imageSize.height;
        const canvasRatio = canvasSize.width / canvasSize.height;
        if (imageRatio > canvasRatio) {
            return { width: canvasSize.width, height: canvasSize.width / imageRatio };
        }
        return { width: canvasSize.height * imageRatio, height: canvasSize.height };
    };
    exports.getRenderedSize = getRenderedSize;
    const getSubPolygon = (points, index, count) => {
        const i = (index + points.length) % points.length;
        const subPolygon = points.slice(i, i + count);
        return [...subPolygon, ...(subPolygon.length < count ? points.slice(0, Math.min(count - subPolygon.length, i)) : [])];
    };
    exports.getSubPolygon = getSubPolygon;
});
//# sourceMappingURL=utils.js.map